import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const ArrowSidebarSvg = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M15 5L10 10L15 15' stroke='#A3ADB7' strokeLinecap='round' strokeLinejoin='round' />
    <line
      x1='6.3335'
      y1='3.83331'
      x2='6.3335'
      y2='16.1666'
      stroke='#A3ADB7'
      strokeLinecap='round'
    />
  </svg>
);

export const ArrowSidebarIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowSidebarSvg} {...props} />
);
